module.exports = __webpack_public_path__ + "assets/worker.png?2cbf5d6ce78fd3ac35470e3dfadb1ee8";